/* import __COLOCATED_TEMPLATE__ from './conversation-access-team-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();